import { useMemo } from 'react';

import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import { COMPANY } from 'models/company.model';
import { CATEGORY_TYPE } from 'models/documents.model';

import { CertificatesPageTabsEnum } from '../../constants';

const useConfig = () => {
  const { currentUser } = useAuthenticatedContext();

  const config = useMemo<any>(() => {
    const categories = [
      CATEGORY_TYPE.CHEMISTRY,
      CATEGORY_TYPE.BATTERY_CELLS,
      CATEGORY_TYPE.BATTERY_PACKS,
      CATEGORY_TYPE.BATTERY_TECH_REVIEW,
      CATEGORY_TYPE.BATTERY_PACKS_REPAIR,
      CATEGORY_TYPE.BATTERY_REPURPOSE,
      CATEGORY_TYPE.BATTERY_PACKS_RECYCLING,
      CATEGORY_TYPE.BATTERY_WASTE,
      CATEGORY_TYPE.CERTIFICATE,
    ];

    const myCertificateCategories = [CATEGORY_TYPE.CERTIFICATE];

    if (currentUser?.category) {
      myCertificateCategories.push(currentUser.category);
    }

    switch (currentUser?.company) {
      case COMPANY.AUTHORITIES:
        return {
          categoriesByTabs: {
            [CertificatesPageTabsEnum.FAVOURITE_CERTIFICATES]: categories,
            [CertificatesPageTabsEnum.BROWSE_CERTIFICATES]: categories,
          },
        };
      default:
        return {
          categoriesByTabs: {
            [CertificatesPageTabsEnum.MY_CERTIFICATES]: myCertificateCategories,
            [CertificatesPageTabsEnum.FAVOURITE_CERTIFICATES]: categories,
            [CertificatesPageTabsEnum.BROWSE_CERTIFICATES]: categories,
          },
        };
    }
  }, [currentUser?.category, currentUser?.company]);

  return config;
};

export default useConfig;
